import BaseApi from '../BaseApi';
import { GeneralReportApiConverter } from './GeneralReportApiConverter';

class GeneralReportApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin`;
    this.converter = new GeneralReportApiConverter();
  }

  getStatisticProvider = (requestedBody) => {
    return this.sendQuery(this.queryTypes.GET, `${this.baseUrl}/agent_structure_provider_statistic`, requestedBody, null, data =>
      this.converter.convertStatisticProvider(data),
    );
  }
}

export default GeneralReportApi;
